import React, { useEffect, useRef, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial, useStylesAutoBlack,
    useStylesAutoSafe,
} from '../../../../St/Reports/UseStyle';
import { Button, colors } from '@material-ui/core';
import { Save } from '@material-ui/icons';
import { useTranslation } from "react-i18next";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

export default function MainInvoiceDownItems(props) {
    const {
        rptParams,
        subInfo,
        isOpenUpdate,
        isStock,
        isPurches,
        AutoOptions,
        valueItemUnits,
        optionsCurrUnits,
        changAutoCurrUnits,
        setting,
        onChangeSearchNormal,
        onChangeData,
        onChangeAutoCurrNormal,
        changInfo,
        getrowDataCurrencie,
        permistionInv,
        autocompleteref,
        or,
        handleFocus,
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAutoBlack();
    const clasTF = useStylesTF();
    const clasui = useStylesUiElemment();
    const { t } = useTranslation(["forms", "translation"]);
    const claslbls = useStylesLbl();
    const clasSaf = useStylesAutoSafe();
    const [autoFucus, setAutoFucus] = useState(false);
    const downnloadItem = (event) => {
        getrowDataCurrencie("main");
    };
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={2} md={2} sm={3} xs={8} style={{ paddingBottom: "0.5rem" }}>
                    <TextField
                        type="text"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcodenormal"
                        label={t("forms:barcode")}
                        style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50] }}
                        name="barcode"
                        autoFocus={true}
                        disabled={or.postput == "toPut" && !isOpenUpdate ? true : false}
                        value={rptParams.barcodeNormal}
                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    onChangeSearchNormal(event);
                                    // document.getElementById("val11").focus();
                                }
                            },
                        }}
                        onFocus={handleFocus}

                        onChange={onChangeData("barcodeNormal")} />
                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={7} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                        value={rptParams.curr}
                        onChange={(event, newValue) => {
                            onChangeAutoCurrNormal("curr", newValue);
                        }}
                        id="items_search"
                        ref={autocompleteref}
                        options={AutoOptions.InvItems}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }

                        disableClearable
                        style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50] }}
                        fullWidth
                        disabled={or.postput == "toPut" && !isOpenUpdate ? true : false}
                        variant="outlined"
                        size="small"
                        autoFocus={false}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("search_item")}
                                variant="outlined"
                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                            />
                        )}
                    />
                </Grid>

                <Grid item lg={1} md={2} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasAo}
                        value={valueItemUnits}
                        onChange={(event, newValue) => {
                            changAutoCurrUnits(event, newValue);
                        }}
                        id="controllable-states-dem"
                        size="small"
                        options={optionsCurrUnits}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.unitName
                        }
                        style={{}}
                        disableClearable
                        disabled={or.postput == "toPut" && !isOpenUpdate ? true : false}
                        renderInput={(params) => (
                            <TextField
                                id="valueCurrUnits"
                                {...params}
                                label={t("unit")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clor }}
                            />
                        )}
                    />
                </Grid>
                <Grid item lg={1} md={2} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="val11"
                        label={t("quanity")}
                        type="number"
                        className={clasTF.rootCust}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        onFocus={handleFocus}
                        autoFocus={autoFucus}
                        disabled={or.postput == "toPut" && !isOpenUpdate ? true : false}
                        InputProps={{
                            className: claslbl.clrBlackTxt,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    if (permistionInv.USP) {
                                        document.getElementById("Price").focus();
                                    } else {
                                        if ((permistionInv?.APDC === 2 || permistionInv.APDC === 3) &&
                                            permistionInv.DSOI == 1) {
                                            document.getElementById("discount").focus();
                                        } else if ((permistionInv.APDC === 1 || permistionInv.APDC === 3) &&
                                            permistionInv.DSOI == 1) {
                                            document.getElementById("DiscPers").focus();
                                        } else if (permistionInv.SVU) {
                                            document.getElementById("taxperc").focus();
                                        } else {
                                            document.getElementById("notes").focus();
                                        }
                                    }
                                }
                            },
                        }}
                        name="subInfo"
                        value={subInfo.val1}
                        onChange={changInfo("val1")} />
                </Grid>
                <Grid item lg={1} md={2} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="Price"
                        label={setting.priceNM}
                        type="number"
                        // disabled={ !permistionInv.USP}
                        disabled={or.postput == "toPut" && !isOpenUpdate ? true : !permistionInv.USP}
                        className={clasTF.rootCust}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        onFocus={handleFocus}
                        InputProps={{
                            className: claslbl.clrBlackTxt,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    if ((permistionInv?.APDC === 2 || permistionInv.APDC === 3) &&
                                        permistionInv.DSOI == 1) {
                                        document.getElementById("discount").focus();
                                    } else if ((permistionInv.APDC === 1 || permistionInv.APDC === 3) &&
                                        permistionInv.DSOI == 1) {
                                        document.getElementById("DiscPers").focus();
                                    } else if (permistionInv.SVU) {
                                        document.getElementById("taxperc").focus();
                                    } else {
                                        document.getElementById("notes").focus();
                                    }
                                }
                            },
                        }}
                        name="notes" value={subInfo.Price}
                        onChange={changInfo("Price")} />
                </Grid>
                {(permistionInv?.APDC === 2 || permistionInv.APDC === 3) &&
                    permistionInv.DSOI == 1 && (
                        <Grid item lg={1} md={2} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                            <TextField fullWidth variant="outlined" size="small"
                                id="discount"
                                label={t("discount-amount")}
                                type="number"
                                className={clasTF.rootCust}
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                onFocus={handleFocus}
                                disabled={or.postput == "toPut" && !isOpenUpdate ? true : false}
                                InputProps={{
                                    className: claslbl.clrBlackTxt,
                                    onKeyDown: (event) => {
                                        if (event.key === 'Enter') {
                                            if (permistionInv.SVU) {
                                                document.getElementById("taxperc").focus();
                                            } else {
                                                document.getElementById("notes").focus();
                                            }
                                        }
                                    },
                                }}
                                name="discount" value={subInfo.discount}
                                onChange={changInfo("discount")} />
                        </Grid>
                    )}
                {(permistionInv.APDC === 1 || permistionInv.APDC === 3) &&
                    permistionInv.DSOI == 1 && (
                        <Grid item lg={1} md={2} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                            <TextField fullWidth variant="outlined" size="small"
                                id="DiscPers"
                                label={t("discount") + "%"}
                                type="number"
                                className={clasTF.rootCust}
                                disabled={or.postput == "toPut" && !isOpenUpdate ? true : false}
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                onFocus={handleFocus}
                                InputProps={{
                                    className: claslbl.clrBlackTxt,
                                    onKeyDown: (event) => {
                                        if (event.key === 'Enter') {
                                            if (permistionInv.SVU) {
                                                document.getElementById("taxperc").focus();
                                            } else {
                                                document.getElementById("notes").focus();
                                            }
                                        }
                                    },
                                }}
                                name="DiscPers" value={subInfo.DiscPers}
                                onChange={changInfo("DiscPers")} />
                        </Grid>
                    )}
                {permistionInv.SVU && (
                    <Grid item lg={1} md={2} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="taxperc"
                            label={t("value-tax")}
                            type="number"
                            className={clasTF.rootCust}
                            disabled={or.postput == "toPut" && !isOpenUpdate ? true : false}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            onFocus={handleFocus}
                            InputProps={{
                                className: claslbl.clrBlackTxt,
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        document.getElementById("notes").focus();
                                    }
                                },
                            }}
                            name="taxperc" value={subInfo.taxperc}
                            onChange={changInfo("taxperc")} />
                    </Grid>
                )}

                <Grid item lg={2} md={3} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="notes"
                        label={t("note")}
                        type="text"
                        className={clasTF.rootCust}
                        disabled={or.postput == "toPut" && !isOpenUpdate ? true : false}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        onFocus={handleFocus}
                        InputProps={{
                            className: claslbl.clrBlackTxt,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    downnloadItem(event);
                                    document.getElementById("barcodenormal").focus();
                                }
                            },
                        }}
                        name="notes" value={subInfo.notes}
                        onChange={changInfo("notes")} />
                </Grid>
                <Grid item lg={1} md={1} sm={1} xs={2} >
                    <Grid item lg={1} md={1} sm={1} xs={2} >
                        <Button
                            fullWidth
                            autoFocus
                            variant="contained"
                            color="primary"
                            disabled={or.postput == "toPut" && !isOpenUpdate ? true : false}
                            onClick={(event) => downnloadItem(event)}
                            style={{
                                background: isPurches ? "#008080" : isStock ? "#3f51b5" : colors.green[500],
                                ...{
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                },
                            }}
                            startIcon={<ArrowDownwardIcon />}
                        >
                            {"تنزيل"+"  "}
                        </Button>
                    </Grid>
                </Grid>

            </Grid>

        </React.Fragment>

    );

}